import React from 'react';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';
import SwapHorizOutlinedIcon from '@material-ui/icons/SwapHorizOutlined';
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { IconKpiRow, PLANNER_COLORS } from '../../shared_components';

const buildKpiCards = (templates, selectedTemplateId) => {
  const list = templates || [];
  const selected = list.find((t) => t?.id === selectedTemplateId);
  const activeCount = list.filter((t) => t?.is_active !== false).length;
  return [
    { key: 'stages', icon: LayersOutlinedIcon, label: 'Total Stages', value: selected?.stage_count ?? 0, sub: 'Active workflow', color: PLANNER_COLORS.blue },
    { key: 'transitions', icon: SwapHorizOutlinedIcon, label: 'Transitions', value: selected?.transition_count ?? 0, sub: 'By project/service type', color: PLANNER_COLORS.green },
    { key: 'projects', icon: FolderOutlinedIcon, label: 'Linked Projects', value: selected?.plan_count ?? 0, sub: 'Since last published', color: PLANNER_COLORS.orange },
    { key: 'templates', icon: DescriptionOutlinedIcon, label: 'Templates', value: list.length, sub: `${activeCount} active`, color: PLANNER_COLORS.purple },
  ];
};

const StageConfigKpis = ({ templates = [], selectedTemplateId }) => (
  <IconKpiRow cards={buildKpiCards(templates, selectedTemplateId)} />
);

export default StageConfigKpis;
